import classNames from 'classnames';
import { ArrowWrapper } from './styles';

const DropdownArrow: React.FC<{ open: boolean; color?: string }> = props => {
  const { open, color = 'var(--primary)' } = props;
  return (
    <ArrowWrapper size={[0, 0]} className={classNames({ open: open })}>
      <div className="arrow-left arrow" style={{ background: color }} />
      <div className="arrow-right arrow" style={{ background: color }} />
    </ArrowWrapper>
  );
};

export default DropdownArrow;
